"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Customer_1 = require("./Customer");
const Vehicle_1 = require("./Vehicle");
const Collection_1 = require("./Collection");
const Dealer_1 = require("./Dealer");
const ValuationData_1 = require("./ValuationData");
class Valuation {
    constructor() {
        /**
         * The customers information who created the valuation.
         */
        this.customer = new Customer_1.Customer();
        /**
         * Vehicle information for which valuation is.
         */
        this.vehicle = new Vehicle_1.Vehicle();
        /**
         * The preferred dealer for the cars valuation.
         */
        this.preferredDealer = new Dealer_1.default();
        /**
         * Answered questionnaire information.
         */
        this.questions = new Collection_1.default();
        this.customer = new Customer_1.Customer();
        this.vehicle = new Vehicle_1.Vehicle();
        this.valuationData = new ValuationData_1.default();
    }
    getVrm() {
        return this.vrm;
    }
    setVrm(vrm) {
        this.vrm = vrm;
        return this;
    }
    getMileage() {
        return this.mileage;
    }
    setMileage(mileage) {
        this.mileage = mileage;
        return this;
    }
    getCustomer() {
        return this.customer;
    }
    setCustomer(customer) {
        this.customer = customer;
        return this;
    }
    getEquity() {
        return this.equity;
    }
    setEquity(valuation) {
        this.equity = valuation;
        return this;
    }
    getValuationData() {
        return this.valuationData;
    }
    setValuationData(data) {
        this.valuationData = data;
        return this;
    }
    getVehicle() {
        return this.vehicle;
    }
    setVehicle(vehicle) {
        this.vehicle = vehicle;
        return this;
    }
    getToken() {
        return this.token;
    }
    setToken(token) {
        this.token = token;
        return this;
    }
    getStatus() {
        return this.status;
    }
    setStatus(status) {
        this.status = status;
        return this;
    }
    isCompleted() {
        return this._isCompleted;
    }
    setCompleted(value) {
        this._isCompleted = value;
        return this;
    }
    getSource() {
        return this.source;
    }
    setSource(value) {
        this.source = value;
        return this;
    }
    getSourceUrl() {
        return this.sourceUrl;
    }
    setSourceUrl(value) {
        this.sourceUrl = value;
        return this;
    }
    getCreatedAt() {
        return this.createdAt;
    }
    setCreatedAt(data) {
        this.createdAt = data;
        return this;
    }
    getUpdatedAt() {
        return this.updatedAt;
    }
    setUpdatedAt(data) {
        this.updatedAt = data;
        return this;
    }
    getExpiredAt() {
        return this.expiredAt;
    }
    setExpiredAt(data) {
        this.expiredAt = data;
        return this;
    }
    getOutstandingFinance() {
        return this.outstandingFinance;
    }
    setOutstandingFinance(value) {
        this.outstandingFinance = value;
        return this;
    }
    getContext() {
        return this.context;
    }
    setContext(value) {
        this.context = value;
        return this;
    }
    getContextMessage() {
        if (this.context && this.context.message) {
            return this.context.message;
        }
        return null;
    }
    getAnsweredQuestionnaires() {
        return this.questions;
    }
    setAnsweredQuestionnaires(questions) {
        this.questions = questions;
        return this;
    }
    getReturnLink() {
        return this.returnLink;
    }
    setReturnLink(value) {
        this.returnLink = value;
        return this;
    }
    setPreferredDealer(value) {
        this.preferredDealer = value;
        return this;
    }
    getPreferredDealer() {
        return this.preferredDealer;
    }
    isExpired() {
        return !this.getExpiredAt() ||
            new Date(this.getExpiredAt()) < new Date();
    }
    setActualPrice(price) {
        this.actualPrice = price;
        return this;
    }
    getActualPrice() {
        return this.actualPrice;
    }
}
exports.default = Valuation;
